// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

import { hasOnePermission } from '../../../services/user/actions';

const Component: React.LazyExoticComponent<any> = React.lazy(() => import('../components/dashboard/Notifications'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    // const access: boolean = hasOnePermission(['thralarms_ro', 'thralarms_rw']);
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Alarms | Notifications',
        component: Component,
        props: {
          report: 'ALARMS_NOTIFICATIONS',
          title: 'Notifications',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
